import React, { useContext, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { V2Context } from './V2Context';
import { navSections, pageTitle } from './navConfig';

// The V2 layout: a side menu, a top bar and the page. Nothing of the current site's navbar is used here.
export default function V2Shell() {
  const { user, signOut } = useContext(AuthContext);
  const { mode, toggleMode } = useContext(V2Context);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const leave = () => {
    signOut();
    navigate('/v2/signin');
  };

  return (
    <div className="v2-shell">
      <div className={`v2-backdrop${open ? ' show' : ''}`} onClick={() => setOpen(false)} role="presentation" />
      <aside className={`v2-side${open ? ' open' : ''}`} aria-label="Menu">
        <div className="v2-brand">CMA <small>V2</small></div>
        <nav className="v2-nav" aria-label="Pages">
          {navSections.map((section) => (
            <div key={section.label}>
              <div className="v2-section">{section.label}</div>
              {section.items.map((item) => (
                <NavLink key={item.path} to={item.path} onClick={() => setOpen(false)}><span className="ico" aria-hidden="true">{item.icon}</span>{item.label}</NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="v2-side-foot">
          <a href="/home">Back to the current site</a>
        </div>
      </aside>
      <div className="v2-main">
        <header className="v2-top">
          <button type="button" className="v2-iconbtn v2-menu-btn" aria-label="Open the menu" onClick={() => setOpen((v) => !v)}>&#9776;</button>
          <strong>{pageTitle(location.pathname)}</strong>
          <span className="grow" />
          <button type="button" className="v2-iconbtn" onClick={toggleMode} aria-label={mode === 'dark' ? 'Switch to the light theme' : 'Switch to the dark theme'}>
            {mode === 'dark' ? 'Light' : 'Dark'}
          </button>
          <span className="v2-user">{user?.username}</span>
          <button type="button" className="v2-iconbtn" onClick={leave}>Sign out</button>
        </header>
        <main className="v2-page"><Outlet /></main>
      </div>
    </div>
  );
}
